/*
 * AZUA — Cart Promocional ("quanto falta" no cart drawer)
 * -------------------------------------------------------
 * Feature INDEPENDENTE do free-shipping nativo do tema. Mostra até duas metas,
 * cada uma com sua PRÓPRIA barra e MÉTRICA:
 *   - Frete grátis: por VALOR (centavos), muda por região (RS / demais).
 *   - Desconto:     por QUANTIDADE de peças DO MESMO PRODUTO (ex.: 25% ao levar 4
 *                   unidades de um mesmo produto; variações do produto somam juntas).
 * O nome do produto líder (o de maior quantidade) entra nos textos via placeholder
 * {produto} — ex.: "...para 25% no {produto}" vira "...para 25% no Vestido Azul".
 * Config vem dos data-attributes do snippet cart-promocional.liquid.
 *
 * Região do frete: 1º CEP digitado no cálculo de frete (localStorage azua:cep,
 * CEP começando com 9 = RS); 2º palpite geo-IP; 3º nacional.
 * Dual: no browser dirige o DOM; no Node exporta as funções puras (test/cart-goals.test.mjs).
 */
(function (root) {
  'use strict';

  // ---- Helpers puros (testáveis) ------------------------------------------

  function regionFromCep(cep) {
    var digits = String(cep == null ? '' : cep).replace(/\D/g, '');
    if (digits.length !== 8) return null;
    return digits.charAt(0) === '9' ? 'RS' : 'BR';
  }

  function regionFromGeo(geo) {
    if (!geo) return null;
    var country = (geo.country_code || geo.countryCode || geo.country || '').toString().toUpperCase();
    if (country && country !== 'BR' && country !== 'BRAZIL' && country !== 'BRASIL') return null;
    var uf = (geo.region_code || geo.regionCode || geo.region || geo.state || '').toString().toUpperCase();
    if (uf === 'RS' || uf.indexOf('RIO GRANDE DO SUL') !== -1) return 'RS';
    return country ? 'BR' : null;
  }

  function freeshipThreshold(cfg, region) {
    return region === 'RS' ? cfg.freeshipRs : cfg.freeshipBr;
  }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  // Produto "líder" da meta de desconto: o de MAIOR quantidade acumulada (variações
  // do mesmo product_id somam juntas). Retorna { qty, title } — a qty vira a métrica
  // e o title alimenta o placeholder {produto} na mensagem.
  function sameProductLeader(items) {
    if (!items || !items.length) return { qty: 0, title: '' };
    var byProduct = {};
    var lead = { qty: 0, title: '' };
    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      var key = it.product_id != null ? it.product_id : it.handle;
      if (key == null) continue;
      var acc = (byProduct[key] || 0) + (it.quantity || 0);
      byProduct[key] = acc;
      if (acc > lead.qty) {
        lead = { qty: acc, title: String(it.product_title || it.title || it.handle || '') };
      }
    }
    return lead;
  }

  // "R$ 1.234,56" — determinístico.
  function formatBRL(cents) {
    cents = Math.max(0, Math.round(cents || 0));
    var reais = Math.floor(cents / 100);
    var rest = cents % 100;
    var intStr = String(reais).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + intStr + ',' + (rest < 10 ? '0' : '') + rest;
  }

  // Metas ativas. Frete = métrica 'value' (centavos). Desconto = 'qtySame' (peças do
  // mesmo produto) e PROGRESSIVO: um array `tiers` ascendente (ex.: 2→15%, 4→25%);
  // a barra vai até a faixa máxima (threshold).
  function buildGoals(cfg, region) {
    var goals = [];
    if (cfg.freeshipEnable) {
      goals.push({ key: 'freeship', metric: 'value', threshold: freeshipThreshold(cfg, region),
        label: cfg.freeshipLabel, reachedLabel: cfg.freeshipReached });
    }
    if (cfg.discountEnable && cfg.discountQty > 0) {
      var tiers = [];
      // Faixa intermediária (menor), só se válida e abaixo da máxima.
      if (cfg.discountTier1Enable && cfg.discountTier1Qty > 0 && cfg.discountTier1Qty < cfg.discountQty) {
        tiers.push({ qty: cfg.discountTier1Qty, label: cfg.discountTier1Label, won: cfg.discountTier1Won });
      }
      tiers.push({ qty: cfg.discountQty, label: cfg.discountLabel, reached: cfg.discountReached });
      goals.push({ key: 'discount', metric: 'qtySame', threshold: cfg.discountQty,
        label: cfg.discountLabel, reachedLabel: cfg.discountReached, tiers: tiers });
    }
    return goals.filter(function (g) { return g.threshold > 0; });
  }

  // Estado de uma meta dado o carrinho { value: centavos, qty: peças totais,
  // qtySame: maior nº do mesmo produto, qtySameTitle: nome desse produto }.
  function goalState(goal, cart) {
    var current;
    if (goal.metric === 'value') current = cart.value || 0;
    else if (goal.metric === 'qtySame') current = cart.qtySame || 0;
    else current = cart.qty || 0;
    var reached = current >= goal.threshold;
    var fillPct = goal.threshold > 0 ? clamp((current / goal.threshold) * 100, 0, 100) : 0;
    return { current: current, reached: reached, fillPct: fillPct,
      remaining: Math.max(0, goal.threshold - current),
      leaderTitle: goal.metric === 'qtySame' ? (cart.qtySameTitle || '') : '' };
  }

  // Troca o placeholder {produto} pelo nome do produto líder (se houver).
  function fillProductToken(text, title) {
    if (text.indexOf('{produto}') === -1) return text;
    var name = (title == null ? '' : String(title)).trim();
    return text.replace(/\{produto\}/g, name).replace(/\s{2,}/g, ' ').trim();
  }

  function pluralPecas(n) { return n + (n === 1 ? ' peça' : ' peças'); }

  // Mensagem do desconto progressivo: comemora a faixa já conquistada e/ou mostra
  // quanto falta pra próxima. Faixas em `goal.tiers` (ascendente).
  function tieredDiscountMessage(goal, st, cfg) {
    var qty = st.current;
    var tiers = goal.tiers;
    var unlocked = null, next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].qty) unlocked = tiers[i];
      else if (next === null) next = tiers[i];
    }
    // Já pegou a faixa máxima: só a celebração final.
    if (next === null) {
      var top = tiers[tiers.length - 1];
      return fillProductToken(top.reached || top.won || top.label, st.leaderTitle);
    }
    var progress = (cfg.prefix + ' ' + pluralPecas(next.qty - qty) + ' para ' + next.label).trim();
    // Ainda não ganhou nada: só o progresso pra 1ª faixa.
    if (unlocked === null) return fillProductToken(progress, st.leaderTitle);
    // Ganhou uma faixa e há próxima: celebração curta + progresso.
    var won = unlocked.won || unlocked.reached || unlocked.label;
    return fillProductToken((won + ' ' + progress).trim(), st.leaderTitle);
  }

  // Texto da meta.
  function goalMessage(goal, st, cfg) {
    if (goal.tiers && goal.tiers.length) return tieredDiscountMessage(goal, st, cfg);
    if (st.reached) return fillProductToken(goal.reachedLabel, st.leaderTitle);
    var rem = goal.metric === 'value'
      ? formatBRL(st.remaining)
      : pluralPecas(st.remaining);
    return fillProductToken((cfg.prefix + ' ' + rem + ' para ' + goal.label).trim(), st.leaderTitle);
  }

  var api = {
    regionFromCep: regionFromCep,
    regionFromGeo: regionFromGeo,
    freeshipThreshold: freeshipThreshold,
    formatBRL: formatBRL,
    sameProductLeader: sameProductLeader,
    buildGoals: buildGoals,
    goalState: goalState,
    goalMessage: goalMessage
  };

  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (typeof document === 'undefined') { root.CartPromocional = api; return; }

  // ---- Browser: efeitos colaterais ---------------------------------------

  if (root.__cartPromocionalInit) return;
  root.__cartPromocionalInit = true;

  var CEP_KEY = 'azua:cep';
  var GEO_KEY = 'azua:georegion';
  var GEO_TTL_MS = 6 * 60 * 60 * 1000; // 6h
  var GEO_URL = 'https://ipwho.is/';

  function ls(getOrSet, key, value) {
    try {
      if (getOrSet === 'get') return root.localStorage.getItem(key);
      root.localStorage.setItem(key, value);
    } catch (e) { /* modo privado */ }
    return null;
  }

  function readConfig(el) {
    var d = el.dataset || {};
    var num = function (v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; };
    return {
      prefix: d.prefix || 'Faltam',
      regionIp: d.regionIp === '1',
      freeshipEnable: d.freeshipEnable === '1',
      freeshipRs: num(d.freeshipRs),
      freeshipBr: num(d.freeshipBr),
      freeshipLabel: d.freeshipLabel || 'o frete grátis',
      freeshipReached: d.freeshipReached || '🎉 Frete grátis liberado!',
      discountEnable: d.discountEnable === '1',
      discountQty: num(d.discountQty),
      discountLabel: d.discountLabel || '25% de desconto',
      discountReached: d.discountReached || '🎉 25% de desconto liberado!',
      discountTier1Enable: d.discountTier1Enable === '1',
      discountTier1Qty: num(d.discountTier1Qty),
      discountTier1Label: d.discountTier1Label || '15% de desconto',
      discountTier1Won: d.discountTier1Won || '🎉 Ganhou 15%!'
    };
  }

  function currentRegionSync() {
    var byCep = regionFromCep(ls('get', CEP_KEY));
    if (byCep) return byCep;
    var raw = ls('get', GEO_KEY);
    if (raw) {
      try { var c = JSON.parse(raw); if (c && c.code && (Date.now() - c.ts) < GEO_TTL_MS) return c.code; }
      catch (e) { /* cache corrompido */ }
    }
    return null;
  }

  var geoInFlight = false;
  function ensureGeoRegion(onResolved) {
    if (regionFromCep(ls('get', CEP_KEY))) return;
    if (currentRegionSync()) return;
    if (geoInFlight || typeof fetch !== 'function') return;
    geoInFlight = true;
    fetch(GEO_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (geo) {
        if (!geo || geo.success === false) return;
        var region = regionFromGeo(geo);
        if (!region) return;
        ls('set', GEO_KEY, JSON.stringify({ code: region, ts: Date.now() }));
        if (onResolved) onResolved();
      })
      .catch(function () { /* mantém nacional */ })
      .then(function () { geoInFlight = false; });
  }

  // { value: centavos, qty: peças totais, qtySame: maior nº do mesmo produto,
  // qtySameTitle: nome desse produto } autoritativo via Shopify.getCart
  // (cart.items traz product_id, quantity e product_title).
  function getCartTotals(cb) {
    if (root.Shopify && typeof root.Shopify.getCart === 'function') {
      try {
        root.Shopify.getCart(function (cart) {
          if (!cart) { cb(null); return; }
          var lead = sameProductLeader(cart.items);
          cb({ value: cart.total_price, qty: cart.item_count, qtySame: lead.qty, qtySameTitle: lead.title });
        });
        return;
      } catch (e) { /* fallback */ }
    }
    cb(null);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function renderEl(el, cart) {
    var cfg = readConfig(el);
    var region = currentRegionSync() || 'BR'; // padrão seguro = nacional
    var goals = buildGoals(cfg, region);
    if (!cart) cart = { value: parseInt(el.dataset.total, 10) || 0, qty: 0, qtySame: 0, qtySameTitle: '' };

    // Esconde com carrinho vazio ou sem metas.
    if (!goals.length || (cart.qty <= 0 && cart.value <= 0)) { el.setAttribute('hidden', ''); return; }
    el.removeAttribute('hidden');
    el.style.removeProperty('display');

    var wrap = el.querySelector('.cart-promo__goals');
    if (!wrap) return;

    var anyReached = false;
    wrap.innerHTML = goals.map(function (g) {
      var st = goalState(g, cart);
      if (st.reached) anyReached = true;
      return '<div class="cart-promo__goal cart-promo__goal--' + g.key + (st.reached ? ' is-reached' : '') + '">' +
               '<p class="cart-promo__text">' + esc(goalMessage(g, st, cfg)) + '</p>' +
               '<div class="cart-promo__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(st.fillPct) + '">' +
                 '<div class="cart-promo__fill" style="width:' + st.fillPct.toFixed(2) + '%"></div>' +
               '</div>' +
             '</div>';
    }).join('');

    el.classList.toggle('is-complete', anyReached);
    // aria-live só na instância realmente visível (evita anúncio duplicado).
    wrap.setAttribute('aria-live', el.offsetParent === null ? 'off' : 'polite');
  }

  function renderAll(cart) {
    var els = document.querySelectorAll('.js-cart-promocional');
    for (var i = 0; i < els.length; i++) renderEl(els[i], cart);
  }

  function refresh() {
    getCartTotals(function (cart) { renderAll(cart || undefined); });
  }

  // Feature separada: NÃO toca em theme.freeShipping. Atualiza via observer do
  // total/contagem do carrinho + init + evento azua:cep (troca de CEP).
  var debounceTimer = null;
  function scheduleRefresh() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 120);
  }
  function attachObserver() {
    if (typeof MutationObserver !== 'function') return;
    var totals = document.querySelectorAll('.js-cart-total, .js-cart-count, .js-cart-items-count');
    if (!totals.length) return;
    var obs = new MutationObserver(scheduleRefresh);
    for (var i = 0; i < totals.length; i++) {
      obs.observe(totals[i], { childList: true, characterData: true, subtree: true });
    }
  }

  function boot() {
    var first = document.querySelector('.js-cart-promocional');
    if (!first) return;
    if (readConfig(first).regionIp) ensureGeoRegion(refresh);
    refresh();
    attachObserver();
    document.addEventListener('azua:cep', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : this);
